module.exports = __webpack_public_path__ + "static/offices-content-image-2-d1da83bff8215975dae4c5a2bcc04638.jpg";